import { FilterConfig } from 'common/models/filter.model';
import { GLOBAL_FILTERS } from './constants';
import { FILTER_ITEMS } from './constants-filter-configs';

export const INSIGHT_SUMMARY_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.insightSourceName,
  FILTER_ITEMS.tags,
];

export const INSIGHT_DETAIL_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.response,
  FILTER_ITEMS.insightSourceName,
  FILTER_ITEMS.tags,
];
export const INSIGHT_COMPARE_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.insightSourceName,
  FILTER_ITEMS.tags,
];

export const INSIGHT_SEGMENT_FILTER: FilterConfig[] = [
  FILTER_ITEMS.accountCountryAbbreviation,
  FILTER_ITEMS.total,
];
